var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitch = function SvgTwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16.422 9.357-2.571 2.571H11.28l-2.25 2.25v-2.25H6.137V2.285h10.285z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9146FF",
    d: "M5.494 1 2.28 4.214v11.572h3.857V19l3.214-3.214h2.572L17.708 10V1zm10.929 8.357L13.85 11.93H11.28l-2.25 2.25v-2.25H6.137V2.286h10.286z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9146FF",
    d: "M14.495 4.536h-1.286v3.857h1.286zM10.958 4.536H9.672v3.857h1.286z"
  })));
};
export default SvgTwitch;